<template>
  <div class="bot-block">
    <div class="text">
      ИМЕЮТСЯ ПРОТИВОПОКАзания. ознакомьтесь с инструкцией
    </div>
  </div>
</template>

<script>
    export default {
        name: "BotBlock"
    }
</script>

<style scoped lang="scss">
  .bot-block {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-size: 100%;
    height: 10%;
    display: flex;
    align-items: flex-end;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
    .text{
      text-transform: uppercase;
      color: #c7c7c7;
      font-size: 3.1vw;
      font-weight: 100;
      text-align: center;
      /* transform: scaleY(2.3543); */
      overflow: hidden;
      margin: 0;
    }
  }

  @media screen and (min-width: 500px) {
    .bot-block {
    }
  }
  @media screen and (min-width: 1600px) {
    .bot-block {
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/BotBlock.vue